import { render, staticRenderFns } from "./NameSearchComponent.vue?vue&type=template&id=4b10e449&scoped=true"
import script from "./NameSearchComponent.vue?vue&type=script&lang=ts"
export * from "./NameSearchComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10e449",
  null
  
)

export default component.exports